"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationAccesses = exports.AccommodationAccessDetails = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
const validator_1 = require("@leavy/validator");
class AccommodationAccessDetails extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.isPresent)
            && this.isPresent ?
            utils_1.Guard.isNotNullish(this.notes) && utils_1.Guard.String.isNotEmpty(this.notes)
            : true);
    }
    toPlain() {
        return { ...this };
    }
}
exports.AccommodationAccessDetails = AccommodationAccessDetails;
class AccommodationAccesses extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.trash) && this.trash.isComplete()
            && utils_1.Guard.isNotNullish(this.gas) && this.gas.isComplete()
            && utils_1.Guard.isNotNullish(this.circuitBreaker) && this.circuitBreaker.isComplete()
            && utils_1.Guard.isNotNullish(this.waterMeter) && this.waterMeter.isComplete()
            && utils_1.Guard.isNotNullish(this.wifi) && this.wifi.isComplete());
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => AccommodationAccessDetails),
    __metadata("design:type", AccommodationAccessDetails)
], AccommodationAccesses.prototype, "trash", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAccessDetails),
    __metadata("design:type", AccommodationAccessDetails)
], AccommodationAccesses.prototype, "gas", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAccessDetails),
    __metadata("design:type", AccommodationAccessDetails)
], AccommodationAccesses.prototype, "circuitBreaker", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAccessDetails),
    __metadata("design:type", AccommodationAccessDetails)
], AccommodationAccesses.prototype, "waterMeter", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAccessDetails),
    __metadata("design:type", AccommodationAccessDetails)
], AccommodationAccesses.prototype, "wifi", void 0);
exports.AccommodationAccesses = AccommodationAccesses;
//# sourceMappingURL=AccommodationAccesses.js.map